const POS_UI_PRINT_CONFIG_KEY = 'pos_ui';

const safeObject = (value) => (
  value && typeof value === 'object' && !Array.isArray(value) ? value : {}
);

export const POS_ZOOM_OPTIONS = Object.freeze(
  Array.from({ length: 11 }, (_, index) => 50 + (index * 10))
);

export const DEFAULT_POS_UI_CONFIG = Object.freeze({
  startCollapsedSaleContext: false,
  useCategoryDropdown: false,
  zoomPercent: 100,
  showSearchBar: true,
  showHeader: true,
  showProductBrand: false,
  abbreviateProductNames: true,
  sendPosSalesToLogistics: false,
  allowCartPriceEdit: false,
  allowDecimalCartQuantity: false,
});

export const clampPosZoomPercent = (value) => {
  const numericValue = Number.parseInt(String(value ?? ''), 10);

  if (!Number.isFinite(numericValue)) return DEFAULT_POS_UI_CONFIG.zoomPercent;
  if (numericValue <= 50) return 50;
  if (numericValue >= 150) return 150;

  return Math.round(numericValue / 10) * 10;
};

const normalizeRawPosUiConfig = (rawConfig) => ({
  startCollapsedSaleContext:
    typeof rawConfig.startCollapsedSaleContext === 'boolean'
      ? rawConfig.startCollapsedSaleContext
      : DEFAULT_POS_UI_CONFIG.startCollapsedSaleContext,
  useCategoryDropdown:
    typeof rawConfig.useCategoryDropdown === 'boolean'
      ? rawConfig.useCategoryDropdown
      : DEFAULT_POS_UI_CONFIG.useCategoryDropdown,
  zoomPercent: clampPosZoomPercent(rawConfig.zoomPercent),
  showSearchBar:
    typeof rawConfig.showSearchBar === 'boolean'
      ? rawConfig.showSearchBar
      : DEFAULT_POS_UI_CONFIG.showSearchBar,
  showHeader:
    typeof rawConfig.showHeader === 'boolean'
      ? rawConfig.showHeader
      : DEFAULT_POS_UI_CONFIG.showHeader,
  showProductBrand:
    typeof rawConfig.showProductBrand === 'boolean'
      ? rawConfig.showProductBrand
      : DEFAULT_POS_UI_CONFIG.showProductBrand,
  abbreviateProductNames:
    typeof rawConfig.abbreviateProductNames === 'boolean'
      ? rawConfig.abbreviateProductNames
      : DEFAULT_POS_UI_CONFIG.abbreviateProductNames,
  sendPosSalesToLogistics:
    typeof rawConfig.sendPosSalesToLogistics === 'boolean'
      ? rawConfig.sendPosSalesToLogistics
      : DEFAULT_POS_UI_CONFIG.sendPosSalesToLogistics,
  allowCartPriceEdit:
    typeof rawConfig.allowCartPriceEdit === 'boolean'
      ? rawConfig.allowCartPriceEdit
      : DEFAULT_POS_UI_CONFIG.allowCartPriceEdit,
  allowDecimalCartQuantity:
    typeof rawConfig.allowDecimalCartQuantity === 'boolean'
      ? rawConfig.allowDecimalCartQuantity
      : DEFAULT_POS_UI_CONFIG.allowDecimalCartQuantity,
});

export const getPosUiConfigFromPrintConfig = (printConfig) => {
  const normalizedPrintConfig = safeObject(printConfig);
  const rawPosUiConfig = safeObject(normalizedPrintConfig[POS_UI_PRINT_CONFIG_KEY]);
  return normalizeRawPosUiConfig(rawPosUiConfig);
};

export const mergePosUiConfigIntoPrintConfig = (printConfig, posUiPatch) => {
  const normalizedPrintConfig = safeObject(printConfig);
  const currentPosUiConfig = getPosUiConfigFromPrintConfig(normalizedPrintConfig);
  const nextPosUiConfig = normalizeRawPosUiConfig({
    ...currentPosUiConfig,
    ...safeObject(posUiPatch),
  });

  return {
    ...normalizedPrintConfig,
    [POS_UI_PRINT_CONFIG_KEY]: nextPosUiConfig,
  };
};
